import { EffectsModal } from '../EffectsModal';

export const InjuriesModal = ({ event, title }) => EffectsModal({
  title,
  desc: `Whenever possible, numbers of injuries from the ${event} are listed.`,
});
